// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__19VH9","bigColWidth":"Table_bigColWidth__2CzUH","biggerColWidth":"Table_biggerColWidth__1XZXC","row":"Table_row__YtaD8","col":"Table_col__3hANP"};